import EmbeddedBudgetCheckLeadWall from "../../components/EmbeddedBudgetCheckLeadWall";
import EmbeddedBudgetFinalScreen from "../../components/EmbeddedBudgetFinalScreen";
import EmbeddedFormScreen from "../../components/EmbeddedFormScreen";
import FormSteps from "../../components/FormSteps";
import { TFunction } from "../../lib/hooks/useTranslations";
import {
  getEmployedIncomeStep,
  getEmploymentTypeStep,
  getEquityStep,
  getFederalStateStep,
  getRetiredIncomeStep,
  getSelfEmployedIncomeStep,
} from "./steps";
import { BudgetCheckFormValues, BudgetCheckStepName } from "./types";

const getBudgetCheckSteps = (
  t: TFunction,
  hasExplicitOptIn?: boolean,
): FormSteps<BudgetCheckFormValues> => {
  const formSteps = new FormSteps<BudgetCheckFormValues>();

  formSteps.setDefaultComponent(EmbeddedFormScreen);

  formSteps.addStep({
    name: BudgetCheckStepName.federalState,
    label: t("federal_state_sidebar_title"),
    config: getFederalStateStep(t),
    transition: BudgetCheckStepName.employmentType,
  });

  formSteps.addStep({
    name: BudgetCheckStepName.employmentType,
    label: t("employment_type_title"),
    config: getEmploymentTypeStep(t),
    possibleTransitions: [
      BudgetCheckStepName.equity,
      BudgetCheckStepName.selfEmployedIncome,
      BudgetCheckStepName.retiredIncome,
      BudgetCheckStepName.employedIncome,
    ],
    transition: (v) => {
      if (
        v.employmentType === "FREELANCER" ||
        v.employmentType === "SELF_EMPLOYED"
      ) {
        return BudgetCheckStepName.selfEmployedIncome;
      }
      if (v.employmentType === "RETIRED") {
        return BudgetCheckStepName.retiredIncome;
      }
      if (v.employmentType === "UNEMPLOYED") {
        return BudgetCheckStepName.equity;
      }
      return BudgetCheckStepName.employedIncome;
    },
  });

  formSteps.addStep({
    name: BudgetCheckStepName.employedIncome,
    label: t("income_title"),
    config: getEmployedIncomeStep(t),
    transition: BudgetCheckStepName.equity,
  });

  formSteps.addStep({
    name: BudgetCheckStepName.retiredIncome,
    label: t("income_title"),
    config: getRetiredIncomeStep(t),
    transition: BudgetCheckStepName.equity,
  });

  formSteps.addStep({
    name: BudgetCheckStepName.selfEmployedIncome,
    label: t("income_title"),
    config: getSelfEmployedIncomeStep(t),
    transition: BudgetCheckStepName.equity,
  });

  formSteps.addStep({
    name: BudgetCheckStepName.equity,
    label: t("equity_title"),
    config: getEquityStep(t),
    transition: BudgetCheckStepName.contact,
  });

  formSteps.addStep({
    name: BudgetCheckStepName.contact,
    config: {
      hasExplicitOptIn,
    },
    component: EmbeddedBudgetCheckLeadWall,
    transition: BudgetCheckStepName.result,
    hidden: true,
  });
  formSteps.addStep({
    name: BudgetCheckStepName.result,
    config: {},
    component: EmbeddedBudgetFinalScreen,
    isResult: true,
    hidden: true,
  });

  return formSteps;
};

export default getBudgetCheckSteps;
